<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    ModalConsumibles(v-show="modalStatus" :consumible="consumibleToModal" @padre:close="cerrarModal")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Consumibles en Almacenes
              | &nbsp
              a.button.is-dark.is-rounded(@click='backPage')
                i.fas.fa-times
            br
        .columns
          .column.is-6
            input#all.is-checkradio.is-black(type='radio', value='allC' v-model='filter')
            label.is-size-6(for='all') Todos
            input#irgeC.is-checkradio.is-black(type='radio', value='IRGEc' v-model='filter')
            label.is-size-6(for='irgeC') IRGE
            input#tpaC.is-checkradio.is-black(type='radio', value='TPAc' v-model='filter')
            label.is-size-6(for='tpaC') TPA
            input#corpC.is-checkradio.is-black(type='radio', value='CORPc' v-model='filter')
            label.is-size-6(for='corpC') CORPO
            input#ductoC.is-checkradio.is-black(type='radio', value='DUCTOc' v-model='filter')
            label.is-size-6(for='ductoC') Ducto
          .column.has-text-right.is-3.is-offset-3
            router-link.a.button.is-black(to="/Inventario/Consumibles/Nuevo")
              span.icon
                i.fa.fas.fa-plus
              | &nbspConsumible
            | &nbsp
            a.button.is-success(@click="downloadConsumibles")
              span.icon
                i.fa.fas.fa-file-download
              | &nbspDescarga
        .columns
          .column.is-4
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA GIA
            input#eb04H.is-checkradio.is-black(type='radio', value='EB04' v-model='filter')
            label.is-size-6(for='eb04H') EB04 GIA
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORPO GIA
          .column.is-5.is-offset-3
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Marca|Categoría|Modelo|Serie',
                  v-model="query_articulos",
                )
        .columns
          .column.is-3(v-show="resultadoFilter !== ''")
            span.tag.is-warning
              | {{ resultadoFilter }}
        .columns
          TbConsumibles(:consumibles="consumiblesShow" @showModalConsumible='showModalConsumible')
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import ModalConsumibles from './shared/ModalConsumibles.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import TbConsumibles from './TbConsumibles.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'ContainerConsumibles',
    components: { Loader, NavBarInventario, TbConsumibles, ModalConsumibles },
    data() {
      return {
        isLoading: true,
        consumibles: [],
        consumiblesShow: [],
        consumiblesSelect: [],
        filter: 'allC',
        modalStatus: false,
        consumibleToModal: {},
        query_articulos: '',
        resultadoFilter: '',
        almacenes: [],
        almacenSel: 'allC',
      }
    },
    watch: {
      filter() {
        this.resultadoFilter = ''
        this.almacenSel = null
        this.consumiblesShow = []
        switch(this.filter) {
          case 'IRGEc':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 28)
            this.almacenSel = this.almacenes.find( a => a.clave === 'IRGE-ALM')
            break
          case 'TPAc':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 1)
            this.almacenSel = this.almacenes.find( a => a.clave === 'TPA-ALM')
            break
          case 'CORPc':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 105)
            this.almacenSel = this.almacenes.find( a => a.clave === 'CORP-ALM')
            break
          case 'EB04c':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 58)
            this.almacenSel = this.almacenes.find( a => a.clave === 'EB04-ALM')
            break
          case 'EB04':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 49)
            this.almacenSel = this.almacenes.find( a => a.clave === 'EB04-ALG')
            break
          case 'TPA':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 2)
            this.almacenSel = this.almacenes.find( a => a.clave === 'TPA-ALS')
            break
          case 'CORP':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 106)
            this.almacenSel = this.almacenes.find( a => a.clave === 'CORP-ALG')
            break
          case 'DUCTOc':
            this.consumiblesShow = this.consumibles.filter( cons => cons.almacen == 95 || cons.almacen == 88 || cons.almacen == 84 || cons.almacen == 76 || cons.almacen == 68 || cons.almacen == 58)
            this.almacenSel = 'ducto'
            break
          case 'allC':
            this.consumiblesShow = this.consumibles
            this.almacenSel = 'allc'
            break
          default:
            break
        }
      },
      query_articulos() {
        this.resultadoFilter = ''
        if (this.query_articulos !== '') {
          this.consumiblesShow = []
          const QUERY_ARTICULOS = this.query_articulos.toUpperCase()
          const consumibles = this.consumibles.filter( cons => {
            return `${cons.modelo} ${cons.marca} ${cons.categoria} ${cons.subcategoria}`.toUpperCase().includes(QUERY_ARTICULOS)
          })
          this.consumiblesShow = consumibles
          this.resultadoFilter = `Coinicidencias: ${this.consumiblesShow.length} artículo${this.consumiblesShow.length == 1 ? '' : 's'}`
        } else {
          this.consumiblesShow = this.consumibles
        }
      },
    },
    methods: {
      iniciarComponente() {
        this.obtenerConsumibles()
      },

      obtenerConsumibles() {
        InventarioServices.getConsumibles()
          .then(res => {
            this.consumibles = res.map(this.convertConsumible)
            this.consumiblesSelect = this.consumibles
            this.consumiblesShow = this.consumibles
            this.obtenerAlmacenes()
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      },
      convertConsumible(data) {
        return {
          ...data,
          id: parseInt(data.id),
          exist_CORPO: parseInt(data.exist_CORPO),
          exist_TPA: parseInt(data.exist_TPA),
          exist_EB04: parseInt(data.exist_EB04),
          exist_IRGEc: parseInt(data.exist_IRGEc),
          exist_TPAc: parseInt(data.exist_TPAc),
          exist_CORPOc: parseInt(data.exist_CORPOc),
          exist_EB00c: parseInt(data.exist_EB00c),
          exist_EB01c: parseInt(data.exist_EB01c),
          exist_EB02c: parseInt(data.exist_EB02c),
          exist_EB03c: parseInt(data.exist_EB03c),
          exist_EB04c: parseInt(data.exist_EB04c),
          exist_ERMc: parseInt(data.exist_ERMc),
          limite: parseInt(data.limite),
          almacen: parseInt(data.almacen),
        }
      },

      addConsumible () {
        this.$router.push('/Inventario/Consumibles/Nuevo')
      },
      backConsumible () {
        this.$router.push('/Inventario/Consumibles/Reingreso')
      },

      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backPage () {
        this.$router.back()
      },
      showModalConsumible(cons) {
        InventarioServices.getConsumibles_Out(cons.id, cons.filter)
          .then( data => {
            this.salidasConsumible = data
            cons['salidas'] = data
            this.consumibleToModal = cons
          })
          .catch( e => {
            this.consumibleToModal = {}
            this.displayToast(e.message, 'ban', 'OK')
          })
        this.modalStatus = true
      },
      cerrarModal() {
        this.modalStatus = false
        this.consumibleToModal = {}
      },

      downloadConsumibles () {
        this.isLoading = true
        let nombreFile = ''
        let ubi = ''
        switch(this.filter) {
          case 'IRGEc':
            nombreFile = 'Consumibles_IRGE'
            ubi = this.almacenSel.id_oficina
            break
          case 'TPAc':
            nombreFile = 'Consumibles_TPA'
            ubi = this.almacenSel.id_oficina
            break
          case 'CORPc':
            nombreFile = 'Consumibles_Corporativo'
            ubi = this.almacenSel.id_oficina
            break
          case 'EB04c':
            nombreFile = 'Consumibles_EB04'
            ubi = this.almacenSel.id_oficina
            break
          case 'EB04':
            nombreFile = 'Consumibles_GIA_EB04'
            ubi = this.almacenSel.id_oficina
            break
          case 'TPA':
            nombreFile = 'Consumibles_GIA_TPA'
            ubi = this.almacenSel.id_oficina
            break
          case 'CORP':
            nombreFile = 'Consumibles_GIA_Corporativo'
            ubi = this.almacenSel.id_oficina
            break
          case 'DUCTOc':
            nombreFile = 'Consumibles_Ducto'
            ubi = this.almacenSel
            break
          case 'allC':
            nombreFile = 'Consumibles_General'
            ubi = this.almacenSel
            break
          default:
            nombreFile = ''
            break
        }
        InventarioServices.createExcel_consumibles(ubi, nombreFile)
          .then((res) => {
            const currentUrl = window.location.hostname
            if (res.success) {
              open(`https://${currentUrl}/reportesApp/server/excel/generarInventario_Ubicacion.php?nameFile=${res.file}`, '_blank');
              setTimeout(() => {
                InventarioServices.borrarInventario_Ubicacion(res.file)
                  .then( resDel => {
                    console.log(resDel)
                    this.isLoading = false
                  })
                  .catch((e) => {
                    this.isLoading = false
                    this.displayToast(e.message, 'ban', 'OK')
                  })
              }, 4000)
            } else {
              this.displayToast(res.respuesta, 'ban', 'OK')
              
            }
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      },

      obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },

      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },
    },

    created () {
      this.iniciarComponente()
    },
    
    computed: {
      ...mapState(['userLogin', 'almacenSelect', 'permisos'])
    }
  }
</script>

<style scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerConsumibles.vue